module.exports = __webpack_public_path__ + "static/media/Avdhut_Kamble.e4f73563.jpg";